import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FnModalService, FnTableConfig, FnTableMetaData, FnToasterService, FnUtilService, TABLE_ACTION_TYPE, TableAction } from 'foundation';
import { Subject } from 'rxjs';
import { PosHttpService } from '../../services/pos.http.service';

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrl: './audit-trail.component.scss'
})
export class AuditTrailComponent {

  constructor(private fnModalSvcs: FnModalService, public datepipe: DatePipe, private fnutilservice: FnUtilService, private posHttpSvcs: PosHttpService, private toaster: FnToasterService) {}

  
  ngOnInit(): void {
    this.entityList();
    this.startDate = this.datepipe.transform(this.dateRangeObject.startDate, 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(this.dateRangeObject.endDate, 'yyyy-MM-dd');
  }
  
  maxDateRange = new Date();
  startDate: any;
  endDate: any;
  isLoading: boolean = false;
  selectEntity: any[] = [];
  selectAction: any[] = [];
  entityArray: any[] = [];
  actionArray: any[] = ['CREATE', 'UPDATE', 'DELETE'];

  dateRangeObject = {
    startDate: new Date(),
    endDate: new Date()
  };

  changeDate(event: any) {
    this.startDate = this.datepipe.transform(event.startDate, 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(event.endDate, 'yyyy-MM-dd');
  }


  entityList() {
    this.posHttpSvcs.authPost('v1/ui/getEntityList', 'getEntityList', {}).subscribe((resp: any) => {
      if (resp.isError) {
        this.toaster.error('Entity Name not Selected');
        return;
      }
      this.entityArray = resp.data;
    })
  }

  getEntityDetails() {
    if (this.fnutilservice.isEmptyObject(this.endDate && this.startDate)) {
      this.toaster.error('Please select Date');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectEntity)) {
      this.toaster.error('Please select Entity');
      return;
    }
    if (this.fnutilservice.isEmptyObject(this.selectAction)) {
      this.toaster.error('Please select Action when you want to check');
      return;
    }
    const getData = {
      startDate: this.startDate, 
      endDate: this.endDate,
      entityName: this.selectEntity,
      action: this.selectAction
    };
    this.posHttpSvcs.authPost('v1/ui/getEntityRecords', 'getEntityRecords', getData).subscribe(resp => {
      if (resp.isError) {
        this.toaster.error('Something went wrong');
        return;
      }
      this.tableDataArray = resp.data;
      this.refreshTableData();
    })
    this.isLoading = true;
  }

  refreshTableData() {
    if (this.config.tableAction.closed) {
      this.config.tableAction = new Subject<TableAction>();
    }
    this.config.tableAction.next({
      data: this.tableDataArray,
      action: TABLE_ACTION_TYPE.REFRESH,
    });
  }

  tableDataArray : any =[];

  downloadCsv() {
    const headers = ['Created At', 'Created By', 'Entity Name', 'Action', 'EntityPK'];
    const csvData = (this.tableDataArray as any[]).map(row => [
      row.createdAt || '',
      row.createdBy || '',
      row.entityName || '',
      row.action || '',
      row.entityPK || ''
    ]);

    let csvContent = 'data:text/csv;charset=utf-8,';
    csvContent += headers.join(',') + '\n';
    csvContent += csvData.map(e => e.map(value => `"${value}"`).join(',')).join('\n');

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'Audit_report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  config: FnTableConfig = {
    uniqueKey: 'primaryKey',
    defaultSortKey: 'primaryKey',
    tableAction: new Subject<TableAction>(),
    hideAction: true
  };

  rowMetaArray: FnTableMetaData[] = [
    {
      key: 'primaryKey',
      description: 'Primary Key',
      isHidden: true,
      isSortable: true,
      type: 'number',
    },
    {
      key: 'createdAt',
      description: 'createdAt',
      type: 'datetime',
      isSortable: true,
    },
    {
      key: 'createdBy',
      description: 'Created By',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'entityName',
      description: 'Entity Name',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'action',
      description: 'Action',
      type: 'string',
      isSortable: true,
    },
    {
      key: 'entityPK',
      description: 'Entity PK',
      type: 'number',
      isSortable: true,
    }
  ];
}
